"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var global_1 = require("../../stores/global");
var SleepSettings_1 = __importDefault(require("../../services/SleepSettings"));
var updateSleepMode_1 = __importStar(require("./updateSleepMode"));
var notifications_1 = require("../../selectors/notifications");
var notifications_2 = require("../../stores/notifications");
function checkSleepMode() {
    var action = function (dispatch, getState) {
        var _a = selector(getState()), sleepSettings = _a.sleepSettings, sleepMode = _a.sleepMode, timezone = _a.timezone, sleepNotification = _a.sleepNotification;
        if (!sleepSettings || sleepSettings.length !== 7 || !sleepMode) {
            dispatch((0, global_1.setLastSleepCheck)());
            dispatch((0, global_1.setSleepMode)(false));
            if (sleepNotification) {
                dispatch((0, notifications_2.removeNotification)(sleepNotification.id));
            }
            return;
        }
        var _b = SleepSettings_1.default.shouldSleepNow(SleepSettings_1.default.getCurrentWorkIntervals(sleepSettings, timezone), sleepMode), shouldSleepNow = _b.shouldSleepNow, start = _b.start, end = _b.end;
        dispatch((0, updateSleepMode_1.default)({
            shouldSleepNow: shouldSleepNow,
            start: start,
            end: end,
        }));
    };
    action.type = checkSleepMode.type;
    return action;
}
checkSleepMode.type = "checkSleepMode";
exports.default = checkSleepMode;
var selector = function (state) {
    var _a, _b, _c;
    return {
        sleepSettings: (_a = state.point) === null || _a === void 0 ? void 0 : _a.sleepSettings,
        sleepMode: ((_b = state.point) === null || _b === void 0 ? void 0 : _b.sleepMode) || false,
        timezone: ((_c = state.point) === null || _c === void 0 ? void 0 : _c.timezone) || "Europe/Moscow",
        sleepNotification: (0, notifications_1.selectNotificationByKey)(state, updateSleepMode_1.sleepNotificationKey),
    };
};
//# sourceMappingURL=goToSleepMode.js.map